export const COLOR_PALETTE = {
  primary: {
    main: '#111111',
    light: '#3F3F3F',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#895AD7',
    dark: '#33244C',
    light: '#CFB9FE',
    lighter: '#E6DEFF',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#D20819',
    light: '#F8AEAD',
    dark: '#AC0B28',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#68C196',
    light: '#B9E0D0',
    dark: '#35644E',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#E77344',
    light: '#F3A77B',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#A175E9',
    light: '#DDD2F6',
    dark: '#6F46B3',
    contrastText: '#FFFFFF',
  },
  tag: {
    yellow: '#FCF2AD',
    blue: '#ABBAEB',
    lightOrange: '#F2BA94',
    orange: '#F0926C',
    rose: '#F9A9F0',
    green: '#DDEDD7',
    gold: '#F2D592',
    sky: '#BED9F4',
    edp: '#28FF52',
  },
  divider: '#F2F2F2',
  dividerLight: '#E2E3E6',
  background: {
    default: '#FFFFFF',
    paper: '#FFFFFF',
    lightGray: '#F7F7FA',
    gray: '#C2C2C2',
    lightBrown: '#FBF5EF',
    brown: '#E2D8D0',
  },
  text: {
    primary: '#111111',
    secondary: '#5E636F',
    disabled: '#DBDBDB',
    titles: '#2A2A37',
  },
}
